import {
  AfterViewInit,
  Directive,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';

import { LayoutService } from 'common/dynamic-form/services/layout.service';

import {
  ASIDE_GROUP_NAME,
  CONTENT_GROUP_NAME,
  FOOTER_GROUP_NAME,
  HEADER_GROUP_NAME,
  SUMMARY_GROUP_NAME,
  getFieldGroupByPlace,
  UNDER_FORM_GROUP_NAME,
  PAGE_FOOTER_GROUP_NAME,
} from './layout.utils';

import { ISPFieldConfig, ISPFieldType, ISPFieldTypeLayout } from '../../model';
import { ISPFieldTypeBase } from '../field-type-base.class';
import { GroupConfig } from '../group/model';
import { TemplateConfig } from '../template/model';

/**
 * Base class for layouts in dynamic form
 */
@Directive()
export class LayoutBaseComponent<T extends ISPFieldTypeLayout>
  extends ISPFieldTypeBase<T>
  implements AfterViewInit, OnInit
{
  @ViewChild('layout') layoutElement: ElementRef<HTMLDivElement>;

  @ViewChild('header') headerElement: ElementRef<HTMLElement>;

  @ViewChild('footer') footerElement: ElementRef<HTMLElement>;

  @ViewChild('form') formElement: ElementRef<HTMLElement>;

  @ViewChild('content') contentElement: ElementRef<HTMLElement>;

  @ViewChild('aside') asideElement: ElementRef<HTMLElement>;

  headerGroup?: GroupConfig | TemplateConfig;

  contentGroup?: GroupConfig | TemplateConfig;

  footerGroup?: GroupConfig | TemplateConfig;

  asideGroup?: GroupConfig | TemplateConfig;

  summaryGroup?: GroupConfig | TemplateConfig;

  pageFooterGroup?: GroupConfig | TemplateConfig;

  underFormGroup?: GroupConfig | TemplateConfig;

  otherFields: ISPFieldConfig[];

  constructor(protected readonly layoutService: LayoutService) {
    super();
  }

  protected initializeLayoutService(): void {
    this.layoutService.formLayout = this.layoutElement.nativeElement;
    this.layoutService.formScrollableContainer =
      this.formElement?.nativeElement;
    this.layoutService.formHeader = this.headerElement?.nativeElement;
    this.layoutService.formContent = this.contentElement.nativeElement;
    this.layoutService.formFooter = this.footerElement?.nativeElement;
    this.layoutService.formAside = this.asideElement?.nativeElement;
  }

  ngOnInit(): void {
    // @WARN do not add configs to props, because they are replaced by template on initialize!
    this.asideGroup = getFieldGroupByPlace(
      ASIDE_GROUP_NAME,
      this.field.fieldGroup,
    );
    this.headerGroup = getFieldGroupByPlace(
      HEADER_GROUP_NAME,
      this.field.fieldGroup,
    );
    this.contentGroup = getFieldGroupByPlace(
      CONTENT_GROUP_NAME,
      this.field.fieldGroup,
    );
    this.footerGroup = getFieldGroupByPlace(
      FOOTER_GROUP_NAME,
      this.field.fieldGroup,
    );
    this.summaryGroup = getFieldGroupByPlace(
      SUMMARY_GROUP_NAME,
      this.field.fieldGroup,
    );
    this.pageFooterGroup = getFieldGroupByPlace(
      PAGE_FOOTER_GROUP_NAME,
      this.field.fieldGroup,
    );
    this.underFormGroup = getFieldGroupByPlace(
      UNDER_FORM_GROUP_NAME,
      this.field.fieldGroup,
    );
    this.otherFields = this.field.fieldGroup.filter(
      config =>
        config.type !== ISPFieldType.Group &&
        config.type !== ISPFieldType.Template,
    );
  }

  ngAfterViewInit(): void {
    this.initializeLayoutService();
  }
}
